import { BOB_MARKER } from "../types";

export function VersionMarker() {
  return (
    <div className="version-marker">
      <div>{BOB_MARKER.title}</div>
      <div>Runtime: {BOB_MARKER.runtime}</div>
      <div>Target: {BOB_MARKER.target}</div>
    </div>
  );
}
